import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/content_arrows/down-curved-arrow.svg")